import React from "react";

import ActionsDropdown from "../../../../../components/Dropdown/ActionsDropdown";
import { DateFormat, formatCurrency, formatDate } from "../../../../../utils";
import { ContributionItemProps } from "./types";
import {
  Row,
  DateCell,
  ChangeCell,
  InvestedCell,
  ValueCell,
  KebabCell,
} from "./styles";

export const ContributionRow: React.FC<ContributionItemProps> = ({
  item,
  actions,
}) => {
  const isInflow = item.direction === "in";

  return (
    <Row>
      <DateCell>{formatDate(item.date, DateFormat.DMY_SPACE)}</DateCell>
      <ChangeCell $positive={isInflow}>
        {formatCurrency(item.amount)}
      </ChangeCell>
      <InvestedCell>{formatCurrency(item.investedAtPoint)}</InvestedCell>
      <ValueCell>{formatCurrency(item.portfolioValueAtPoint)}</ValueCell>
      <KebabCell>
        {actions.length > 0 && (
          <ActionsDropdown
            compact
            dropdownActions={actions}
            testId={`contribution-actions-${item.id}`}
          />
        )}
      </KebabCell>
    </Row>
  );
};
